import { HttpParams } from '@angular/common/http';
import { ApiRequest } from './';

export class StreamItemRequestModel implements ApiRequest {
    constructor(public page: number,
                public sortField: string = 'publishedDate',
                public hiddenOnly: boolean = false,
                public displayedOnly: boolean = true,
                public includeFullDescription: boolean = true){}

    asURLSearchParams() {
        return new HttpParams()
        .set('page', String(this.page))
        .set('sortField', String(this.sortField))
        .set('hiddenOnly', String(this.hiddenOnly))
        .set('displayedOnly', String(this.displayedOnly))
        .set('includeFullDescription', String(this.includeFullDescription));
    }
}
